import { Coordinates } from 'types'

export function isInsidePolygon(coordinates: Coordinates, polygon: Coordinates[]): boolean {
    const { x, y } = coordinates
    let isInside = false

    polygon.forEach((point, i) => {
        const nextPoint = polygon[i < polygon.length - 1 ? i + 1 : 0]
        const intersect =
            point.y > y !== nextPoint.y > y &&
            x < ((nextPoint.x - point.x) * (y - point.y)) / (nextPoint.y - point.y) + point.x

        if (intersect) {
            isInside = !isInside
        }
    })

    return isInside
}
